// /api/user/associate/company
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AccountantRequest, AssociateCompanyRequest } from '../models/company.model';

@Injectable({
	providedIn: 'root'
})
export class UserService {
	private URL = environment.api + "api/user";
	constructor(
		private http: HttpClient
	) { }

	createAssociateCompany(newAssociateCompany: AssociateCompanyRequest) {
		return this.http.post(this.URL + "/associate/company", newAssociateCompany);
	}

	checkNIT(nit: string) {
		return this.http.get(this.URL + "/check/nit?&nit=" + nit);
	}

	createAccountant(newAccountant: AccountantRequest) {
		return this.http.post(this.URL + "/partner", newAccountant);
	}

	getPartners(filter: string,
		page: number = 0,
		size: number = 5) {
		return this.http.get(this.URL + "/partners", {
			params: {
				filter: filter,
				page: page,
				size: size
			}
		})
	}

	getPartnersWithoutSizeAndPageAndFilter() {
		return this.http.get(this.URL + "/partners", {
			params: {
				filter: ""
			}
		})
	}

	register(data) {
		return this.http.post(this.URL + "/register", data);
	}

}